import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../modules/login/selectors';


const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const { checked, isAuthed } = useSelector(selectUser);
  if (!checked) return null;
  if (!isAuthed) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}

export default PrivateRoute;